import React, {  useEffect,useState } from "react";
import { getSurveyInfo } from "utils/api";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import { loginUrl } from "utils/api/ajax";
import { useHistory } from "react-router-dom";

import './index.scss'

const SurveyInfo = observer(() => {
  const { loginStore } = useStores();
  const [ surveyInfo, setSurveyInfo ] = useState(true); // 是否需要填写
  const [ surveyInfoUrl, setSurveyInfoUrl ] = useState('');
  const history = useHistory();
  useEffect(()=>{

    if(loginStore.isLogin){
      init()
    }
    
  },[loginStore.isLogin])

  const init = () => {
    // 问卷调研请求
    getSurveyInfo()
    .then(res => {
      // console.log('res', res.data.result)
      if(res.status == 200 && res.data.success) {
        setSurveyInfo(res.data.result.needSurvey);
        setSurveyInfoUrl(res.data.result.surveyPath);
      }
    })
  }

  const handleFeedback = () => {
    if(loginStore.isLogin){
      init();
      if(surveyInfoUrl) {
        window.open(surveyInfoUrl);
      }
    } else {
      history.push(loginUrl);
    }
  }

  return (
    <div className='vop_home_float' onClick={handleFeedback} clstag="pageclick|keycount|VopOpenIndex_1602911919488|33">
        <img
          src="//img13.360buyimg.com/imagetools/jfs/t1/210605/13/13505/1487/61c29711E77508d28/68d5ea0f302626af.png"
          alt=""
        />
        <span>问卷调研</span>
        { surveyInfo && 
          <i className="num"></i>
        }
      </div>
  );
})

export default SurveyInfo;


